module.exports = __webpack_public_path__ + "img/POL.961dcf9b.png";